import React from 'react';
import FeatherIcon from 'feather-icons-react';
import { Input, Label } from 'reactstrap';

/**
 *
 * @param {object} props
 * @param {string} props.prop
 * @param {string} props.label
 * @param {string} props.icon
 * @param {string} props.type
 * @param {boolean} props.required
 * @param {string} props.placeholder
 * @param {function} props.onChange
 * @param {string} props.value
 * @param {boolean} props.valid
 * @param {boolean} props.invalid
 * @returns
 */
const InputComponent = (props) => {
  const { prop, label, icon, type, required, placeholder, onChange, value, valid, invalid } = props;
  const onChangeCore = (e) => onChange(e.target.value);
  return (
    <>
      <Label for={prop}>
        {required && <span className="text-danger mr-1 align-middle">*</span>}
        {label}:
      </Label>
      <div className="position-relative">
        <i className="position-absolute h-100 d-flex align-items-center ml-3">
          <FeatherIcon icon={icon} className="fea icon-sm icons" />
        </i>
        <Input
          id={prop}
          name={prop}
          type={type}
          required={required}
          value={value}
          onChange={onChangeCore}
          placeholder={placeholder}
          valid={valid}
          invalid={invalid}
          className="form-control pl-5 rounded"
        />
      </div>
    </>
  );
};

export default InputComponent;
